import { useEffect, useMemo, useState } from 'react';

import { formatHMS } from '../daily-quests-page.utils';

/**
 * Returns the remaining ms and a formatted HH:MM:SS string until `targetTs`.
 */
export function useCountdown(targetTs?: number) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!targetTs) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [targetTs]);

  const remaining = Math.max(0, (targetTs ?? 0) - now);
  const label = useMemo(() => formatHMS(remaining), [remaining]);

  return { remaining, label };
}
